var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-element',{attrs:{"disabled":!_vm.canConfirm,"type":"dark"},on:{"click":function($event){return _vm.confirmOrder()}}},[_c('fa-icon',{staticClass:"mr-2",attrs:{"fixed-width":"","icon":"check"}}),_vm._v(" Confirm ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }